<forge-divider *ngIf="includeDivider"></forge-divider>
<div *ngIf="showHeader" class="forge-typography--heading2 metadata-header" focusOnLoad [forCellEdit]="forCellEdit">
    {{ label }}
</div>
